import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";
import { useAuth } from "../auth/AuthContext";
import Logout from "../auth/Logout";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const { user } = useAuth();

  return (
    <nav className="navbar">
      <div className="brand">PollChimp</div>
      <button className="toggle" onClick={() => setOpen(!open)}>☰</button>
      <ul className={`links ${open ? "open" : ""}`}>
        <li><Link to="/">Home</Link></li>
        <li><Link to="/portal">Polls</Link></li>

        {user?.token ? (
          <>
            <li><Link to="/createpoll">Create Poll</Link></li>
            <li><Link to="/mypolls">My Polls</Link></li>
            <li><Logout /></li>
          </>
        ) : (
          <>
            <li><Link to="/login">Login</Link></li>
            <li><Link to="/signup">Signup</Link></li>
          </>
        )}
      </ul>
    </nav>
  );
}

